export const SUBSCRIPTION_CHANGE_ROUTE = "/subscription/change-plan";

/** Routes that only unsubscribed users should see (pick-a-plan / checkout). */
export const SUBSCRIPTION_PURCHASE_ROUTES = [
  "/subscribe",
  "/subscription",
  "/checkout",
  "/checkout-form",
  "/subscribe-checkout",
];

const ACTIVE_SUB_STATUSES = new Set(["active", "succeeded"]);

/**
 * True when the user has an active Liber subscription (free or paid).
 * past_due keeps access during Stripe Smart Retries (FR-3.6).
 */
export function hasActiveSubscription(user) {
  if (!user) return false;

  const active = user.active_subscription;
  if (!active || active.is_active === false) return false;

  const status = String(active.status || "active").toLowerCase();
  if (status === "past_due") return true;
  return ACTIVE_SUB_STATUSES.has(status);
}

export function isSubscriptionPastDue(user) {
  const status = String(user?.active_subscription?.status || "").toLowerCase();
  return status === "past_due";
}

/** Login onboarding: only when not subscribed and still on early onboarding steps. */
export function needsSubscriptionOnboarding(user) {
  if (!user || user.user_type === "admin") return false;
  if (hasActiveSubscription(user)) return false;
  const step = Number(user.step);
  return step === 1 || step === 2;
}

/**
 * Subscribed users may open checkout for free→paid upgrade or prorated payment.
 * Survives Stripe redirect via sessionStorage / payment_intent query params.
 */
export function isUpgradeCheckoutAllowed(location) {
  const state = location?.state || {};
  if (state.fromChangePlan || state.clientSecret || state.prorationOnly) {
    return true;
  }
  try {
    const mode = sessionStorage.getItem("checkout_mode");
    if (mode === "new" || mode === "proration") return true;
    if (sessionStorage.getItem("checkout_subscription_id")) return true;
  } catch (_) {
    /* ignore */
  }
  const params = new URLSearchParams(location?.search || "");
  if (
    params.get("payment_intent") ||
    params.get("payment_intent_client_secret") ||
    params.get("setup_intent")
  ) {
    return true;
  }
  return false;
}

export function isSubscriptionPurchaseRoute(pathname, location) {
  const path = String(pathname || "");
  if (
    path === SUBSCRIPTION_CHANGE_ROUTE ||
    path.startsWith(`${SUBSCRIPTION_CHANGE_ROUTE}/`)
  ) {
    return false;
  }
  if (
    (path === "/subscribe-checkout" || path.startsWith("/subscribe-checkout/")) &&
    location &&
    isUpgradeCheckoutAllowed(location)
  ) {
    return false;
  }
  return SUBSCRIPTION_PURCHASE_ROUTES.some(
    (route) => path === route || path.startsWith(`${route}/`),
  );
}

export function clearCheckoutSessionFlags() {
  try {
    sessionStorage.removeItem("checkout_mode");
    sessionStorage.removeItem("checkout_subscription_id");
  } catch (_) {
    /* ignore */
  }
  try {
    localStorage.removeItem("stripe_subscription_id");
  } catch (_) {
    /* ignore */
  }
}
